import Flex from '@eversports/react-components/primitives/Flex'
import React from 'react'
import Skeleton from '@eversports/react-components/primitives/Skeleton'
import { makeStyles } from '@mui/styles'
import { Theme } from '@eversports/react-components/design-tokens/theme'
import DesktopSkeletonBookingDetails from '../../BookingDetails/Skeletons/DesktopSkeletonBookingDetails'
import Page from '../../../boilerplate/Page'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: 840,
    width: '100%',
  },
  heading: {
    [theme.breakpoints.up('sm')]: {
      textTransform: 'uppercase',
    },
  },
  subHeading: {
    maxWidth: 308,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 550,
    },
  },
  hiddenInMobile: {
    width: '100%',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
}))

const ConfirmationSkeleton = () => {
  const classes = useStyles()

  return (
    <Page>
      <Flex justifyContent="center" marginBottom="hero" fullWidth>
        <Flex flexDirection="column" verticalSpacing="wide" alignItems="center" className={classes.container}>
          <Flex alignItems="center" flexDirection="column" marginTop="wide" marginBottom="wide" fullWidth>
            <Flex marginBottom="default">
              <Skeleton variant="circular" height="70px" width="70px" />
            </Flex>
            <Skeleton variant="text" height="60px" width="50%" />
            <Skeleton variant="text" height="60px" width="50%" />
          </Flex>
          <Skeleton variant="rectangular" height="40px" width="30%" />
          <Skeleton variant="rectangular" height="40px" width="30%" />
          <div className={classes.hiddenInMobile}>
            <DesktopSkeletonBookingDetails />
          </div>
          <Skeleton variant="rectangular" height="150px" width="100%" />
        </Flex>
      </Flex>
    </Page>
  )
}

export default ConfirmationSkeleton
